module.exports = __webpack_public_path__ + "static/img/9.cf1bb93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/9.png
// module id = 3peS
// module chunks = 37